import { useEffect, useState } from "react";
import ErrorBackgroundSVG from "../assets/svg/error-background";
import { Box, styled, Typography } from "@mui/material";
import { checkParamErrorEAuth } from "../utils/checkParamReferEauth";
import useMediaQuery from '@mui/material/useMediaQuery';
import theme from '../theme/theme';


const Title = styled(Typography)(({ theme }) => ({
  fontFamily: "Raleway",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "32px",
  lineHeight: "38px",
  display: "flex",
  alignItems: "center",
  fontFeatureSettings: "'pnum' on, 'lnum' on",
  color: "#263057",
}));

const Subtitle = styled(Typography)(({ theme }) => ({
  fontFamily: "Roboto",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "16px",
  lineHeight: "19px",
  display: "flex",
  alignItems: "center",
  fontFeatureSettings: "'pnum' on, 'lnum' on",
  color: "#263057",
}));

export default ({ appCode, refError }) => {
  const [text, setText] = useState({title:'',subtitle: ''});
  const media = useMediaQuery(theme.breakpoints.down('md'));


  useEffect(() => {
    setText(checkParamErrorEAuth(refError, appCode));
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        flexDirection: !media ? "row" : "column",
        height: "100vh",
        width: "100vw",
      }}
    >
      <Box
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
         <ErrorBackgroundSVG height={ !media ? null : "250"} /> 
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "flex-start",
          maxWidth: !media ? "45%" : "100%",
          whiteSpace: 'pre-line',
          gap: "2rem",
          margin:!media ? "0rem" : "2rem",
          marginBottom:"5rem"

          

        }}
      >
        <Title dangerouslySetInnerHTML={{__html:text.title}} ></Title>
        <Subtitle  dangerouslySetInnerHTML={{__html:text.subtitle}} >
        
        </Subtitle>
      </Box>
    </Box>
  );
};
